import React from "react";

const EmptyPlaceholder = ({ 
  title, 
  mainIconClass,
  description, 
  actionLabel, 
  actionIcon,
  onClickAction,
}) => {
  return (
    <div className="col-12 h-100 d-flex flex-column justify-content-center bg-white rounded align-items-center animate__animated animate__fadeIn text-center px-5 py-10 overflow-auto">
      <i className={`${mainIconClass} fa-4x text-muted mb-4 opacity-25 mt-3`}></i>
      <h4 className="text-dark font-weight-bold">{title}</h4>
      <p className="text-muted mb-4" style={{ maxWidth: "500px" }}>
        {description}
      </p>

      {actionLabel && onClickAction && (
        <button type="button" className="btn btn-primary shadow-sm px-4" onClick={onClickAction}>
          {actionIcon && <i className={`${actionIcon} mr-2`}></i>}
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default EmptyPlaceholder;
